import React from "react";
import styles from "./index.module.scss";
import ThreeImageRevolution from "@/components/CustomComponents/ThreeImageRevolution";
import { useRouter } from "next/router";
import { renderRichText } from "@/utils/formatters";

const FeatureCardGrid = ({ featureCardGridData = {} }) => {
  const { cards = [], viewMode = "default", title } = featureCardGridData;
  const router = useRouter();
  const { locale } = router;
  return (
    <>
      {viewMode === "default" ? (
        <>
        {title && <div className={styles.titleContainer}>{title}</div>}
        <div className={styles.container}>
          {cards?.map(card => {
            const { fields: { title, description, richTextDescription, image, cta } = {} } =
              card ?? {};
            const { fields: { imageUrl, src, altText, assets } = {} } =
              image ?? {};
            const { fields: { file } = {} } = assets?.[0] ?? {};
            const { url: assetUrl } = file ?? {};
            const { fields: { url: ctaUrl, label: ctaLabel } = {} } = cta ?? {};

            return (
              <div key={title} className={styles.card}>
                {(imageUrl || assetUrl) && (
                  <a href={src} className={styles.imageWrapper}>
                    <img src={imageUrl || assetUrl} alt={altText} />
                  </a>
                )}
                <h3 className={styles.title}>{title}</h3>
                {richTextDescription ? (
                  <div className={styles.richdescription}>
                    {renderRichText(
                      richTextDescription,
                      locale
                    )}
                  </div>
                ) : description ? ( <p className={styles.description}>{description}</p>) : null}
                <a href={ctaUrl} className={styles.cta}>
                  {ctaLabel}
                </a>
              </div>
            );
          })}
        </div></>
      ) : (
        <ThreeImageRevolution cards={cards} />
      )}
    </>
  );
};

export default FeatureCardGrid;
